import { debounce, kebabCase } from 'lodash';

// Re-export the shared class-merge helper so app code can import from '@/lib/utils'.
export { cn } from '@ibas/ui';

/** URL/anchor-friendly slug, e.g. "Flexi MBA" -> "flexi-mba". */
export function slugify(input: string): string {
  return kebabCase(input);
}

/** Debounce with a typed wrapper (thin passthrough to lodash.debounce). */
export function createDebounced<A extends unknown[]>(
  fn: (...args: A) => void,
  wait = 200,
): (...args: A) => void {
  return debounce(fn, wait);
}

/** Format bytes for human-readable file sizes (used by the upload preview). */
export function formatBytes(bytes: number, decimals = 1): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'] as const;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Number.parseFloat((bytes / k ** i).toFixed(decimals))} ${sizes[i]}`;
}
